/**
 * @file audience.ts
 * @path apps/website/src/data/audience.ts
 * @description Data for the audience-targeted sections of the website.
 * Synchronized with the centralized Navigation Engine.
 */

import { makeLink, PATHS } from "@/config";
import { services } from "./services";
import { Audience } from "@sirbastians/types";

export const audienceData: Audience[] = [
  {
    title: "For the Discerning Traveler",
    description:
      "You value punctuality, comfort, and professionalism. Our private hire and airport transfer service provides a seamless, stress-free travel experience so you can focus on what matters.",
    buttonText: "Book a Transfer",
    // ✨ UPDATED: Uses makeLink.service string generator with a safe fallback to PATHS.EXPERIENCES
    link:
      makeLink.service(
        services.find((s) => s.title === "Airport Transfers")?.slug ?? "",
      ) || PATHS.EXPERIENCES,
  },
  {
    title: "For the Curious Explorer",
    description:
      "You want more than just a ride; you want an authentic experience. Our curated private tours are for those who wish to connect with the culture, history, and beauty of Cape Town on a deeper level.",
    buttonText: "Explore Our Tours",
    link: PATHS.EXPERIENCES,
  },
  {
    title: "For Students & Parents",
    description:
      "Your peace of mind is our top priority. We provide a safe, reliable, and convenient shuttle service for UWC and CPUT students, ensuring a dependable commute for campus life.",
    buttonText: "View Student Routes",
    // ✨ UPDATED: Logic remains identical but points to centralized PATHS for fallback
    link:
      services.find((s) => s.slug === "uwc-cput-student-shuttle")
        ?.externalBookingUrl || PATHS.EXPERIENCES,
  },
];
